/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Empty_Epics_TitleInputs */

const en_tl_empty_epics_title = /** @type {(inputs: Tl_Empty_Epics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No epics or initiatives`)
};

const de_tl_empty_epics_title = /** @type {(inputs: Tl_Empty_Epics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Epics oder Initiativen`)
};

/**
* | output |
* | --- |
* | "No epics or initiatives" |
*
* @param {Tl_Empty_Epics_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_empty_epics_title = /** @type {((inputs?: Tl_Empty_Epics_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Empty_Epics_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_empty_epics_title(inputs)
	return en_tl_empty_epics_title(inputs)
});